import { DoctorProfileStatus } from 'types/api/users';

// Phase E Cycle 2 — values sourced from the canonical BE enum.
// 'all' is an admin-FE-only sentinel meaning "no filter" — the
// Doctors list page elides the status query param when the picker
// is on 'all'. Distinct from any canonical BE status string.
export const DOCTOR_STATUSES = {
  waiting: DoctorProfileStatus.Waiting,
  active: DoctorProfileStatus.Active,
  disabled: DoctorProfileStatus.Disabled,
  all: 'all'
} as const;

export const DOCTOR_STATUS_LABEL = {
  [DOCTOR_STATUSES.active]: 'active',
  [DOCTOR_STATUSES.disabled]: 'disabled',
  [DOCTOR_STATUSES.waiting]: 'waiting',
  [DOCTOR_STATUSES.all]: 'all'
} as const;

export const DOCTOR_STATUS = [
  {
    value: DOCTOR_STATUSES.active,
    label: 'active'
  },
  {
    value: DOCTOR_STATUSES.disabled,
    label: 'disabled'
  },
  {
    value: DOCTOR_STATUSES.waiting,
    label: 'waiting'
  },
  {
    value: DOCTOR_STATUSES.all,
    label: 'all'
  }
];
